import React from "react";
import { QueryRenderer, graphql } from "react-relay";
import environment from "../AuthEnv";
import { ITEMS_PER_PAGE } from "../constants";
import { ROOT_ID } from "relay-runtime";
import PostViewContainer from "./PostViewContainer";
import Spinner from "../Spinner";

const childFeedsQuery = graphql`
    query PostViewContainerWrapperQuery($parent: ID) {
        subscriptions(parent: $parent) {
            ...PostViewContainer_child_Subs
        }
    }
`;

function PostViewContainerWrapper(props) {
    const { selectedParentId } = props.settings;
    const settings = props.settings;
    const user = props.user;

    return (
        <QueryRenderer
            environment={environment}
            query={childFeedsQuery}
            variables={{
                parent: selectedParentId,
            }}
            render={({ error, props }) => {
                if (error) {
                    return <div>Error!</div>;
                }
                if (!props) {
                    return (
                        <div>
                            <Spinner isLoading={true} />
                        </div>
                    );
                }
                return (
                    <div>
                        <PostViewContainer
                            user={user}
                            child_Subs={props.subscriptions}
                            settings={settings}
                        />
                    </div>
                );
            }}
        />
    );
}

export default PostViewContainerWrapper;
